import { httpClient, convResp } from './_http';

/**
 * @desc 获取数据
 * @param {{ startDate: String, endDate: String }} payload
 */
export const fetchFeeConfirmationHistory = (payload) => {
    return httpClient
    .post('/duckBill/listStatisticsCustomerChargeConfirm', payload)
    .then(convResp);
};

/**
 * @desc 月账单支付获取数据
 * @param {{ startDate: String, endDate: String }} payload
 */
export const monthlyBill = (payload) => {
    return httpClient.post('/duckBill/list/billing-report/payment/statistics', payload);
};



// WEBPACK FOOTER //
// ./src/api/feeConfirmation.js